var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    fill: "#159F46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0795 15.5801C10.8795 15.5801 10.6895 15.5001 10.5495 15.3601L7.71945 12.5301C7.42945 12.2401 7.42945 11.7601 7.71945 11.4701C8.00945 11.1801 8.48945 11.1801 8.77945 11.4701L11.0795 13.7701L16.2195 8.6301C16.5095 8.3401 16.9895 8.3401 17.2795 8.6301C17.5695 8.9201 17.5695 9.4001 17.2795 9.6901L11.6095 15.3601C11.4695 15.5001 11.2795 15.5801 11.0795 15.5801Z",
    fill: "#159F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.9556c8c96c47cb5c0df3afd23c98a4d9.svg";
export { ForwardRef as ReactComponent };